"use strict";

var r = require("react");
module.exports = function (e, t) {
  for (var n = [], u = 2; u < arguments.length; u++) {
    n[u - 2] = arguments[u];
  }
  var c = r.useRef();
  r.useEffect(function () {
    c.current = e;
  }, [e]), r.useEffect(function () {
    if (null != t) {
      var r = setInterval(function () {
        c.current && c.current.apply(c, n);
      }, t);
      return function () {
        return clearInterval(r);
      };
    }
  }, [t]);
};